module.exports = __webpack_public_path__ + "img/kontaktlos.bd15a781.png";